import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getExp,
  getToken,
  getUser,
  signin,
  signinExternal
} from '../Auth/authSCG';

export const getUserAsync = createAsyncThunk('userProfile/getUser', signin);
export const getExternalUserAsync = createAsyncThunk(
  'userProfile/getExternalUser',
  signinExternal
);

export interface User {
  id: number;
  firstName: string;
  lastName: string;
}

interface UserProfile {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  isActive: boolean;
  permissions: string[];
}

export interface UserContextType {
  user: UserProfile | null;
  token: string | null;
  exp: number | null;
}

const initialState: UserContextType = {
  user: getUser(),
  token: getToken(),
  exp: getExp()
};

export default createSlice({
  name: 'userProfile',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUserAsync.fulfilled, (state, action) => {
      return action.payload;
    });
    builder.addCase(getExternalUserAsync.fulfilled, (state, action) => {
      return action.payload;
    });
  }
});
